import type { SVGProps } from "react";
const SvgIconPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M736.27 740.28c-34.11 34.11-151.8 79.03-341.69-110.86S249.61 321.85 283.72 287.73l22.74-22.74c15.7-15.7 41.15-15.7 56.85 0l79.59 79.59c15.7 15.7 15.7 41.15 0 56.85l-39.8 39.8s27.86 61.97 72.77 106.88 106.88 72.77 106.88 72.77l39.8-39.8c15.7-15.7 41.15-15.7 56.85 0l79.59 79.59c15.7 15.7 15.7 41.15 0 56.85l-22.74 22.74Z" />
  </svg>
);
export default SvgIconPhone;
